import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Select } from 'antd';
import { makeStyles } from '@material-ui/core/styles';
import { REQUEST, REQUEST_STATUS } from '../../../constants';

const STATUS_LABELS = {
  [REQUEST_STATUS.NEW]: 'New',
  [REQUEST_STATUS.IN_PROGRESS]: 'In Progress',
  [REQUEST_STATUS.PENDING]: 'Pending',
  [REQUEST_STATUS.COMPLETED]: 'Completed'
};

const useStyles = makeStyles(() => {
  return {
    filterTitle: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    clearButton: {
      float: 'right',
      alignSelf: 'center',
      fontSize: 12,
      color: 'gray'
    }
  };
});

const parseInitialValue = rawValue => {
  if (!rawValue || rawValue.length === 0) {
    return {
      request: REQUEST.INITIAL_CASE_SETUP,
      statuses: []
    };
  }
  const [request] = rawValue[0].split('.');
  return { request, statuses: rawValue.map(item => item.split('.')[1]) };
};

const RequestsStatusFilter = ({ value: rawValue, onChange }) => {
  const value = useMemo(() => {
    return parseInitialValue(rawValue);
  }, [rawValue]);

  const { Option } = Select;
  const classes = useStyles();

  const requestsConfig = {
    [REQUEST.INITIAL_CASE_SETUP]: {
      title: 'Initial Case Setup',
      statuses: [
        REQUEST_STATUS.NEW,
        REQUEST_STATUS.IN_PROGRESS,
        REQUEST_STATUS.PENDING,
        REQUEST_STATUS.COMPLETED
      ]
    }
  };

  const triggerOnChange = newValue => {
    if (newValue.request === null) {
      onChange([]);
      return;
    }

    const updateValue = newValue;

    const statuses = updateValue.statuses;
    const filterValues = statuses.map(status => `${updateValue.request}.${status}`);

    onChange(filterValues);
  };

  const onStatusesChange = statuses => {
    const newValue = {
      ...value,
      statuses
    };
    triggerOnChange(newValue);
  };

  const availableStatuses = value.request ? requestsConfig[value.request].statuses : [];

  return (
    <>
      <Grid item xs={4}>
        <Typography component="div" className={classes.filterTitle} variant="subtitle1">
          Filter Request Status
        </Typography>
        <Select
          mode="multiple"
          placeholder="Select specific status"
          style={{ width: '100%' }}
          value={value.statuses}
          onChange={onStatusesChange}
        >
          {availableStatuses.map(status => {
            return (
              <Option value={status} key={status}>
                {STATUS_LABELS[status]}
              </Option>
            );
          })}
        </Select>
      </Grid>
    </>
  );
};

RequestsStatusFilter.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired
};

export default RequestsStatusFilter;
